/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {getServiceT002, putServiceT002} from '../../core/prestation/request'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {Button, Modal} from 'react-bootstrap'
import * as lodash from 'lodash'
import {useAuth} from '../../../../auth'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {ListeServiceStatus} from '../../core/prestation/model'
import {Color} from '../../../../../common/components/Constants/colors.constants'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'

const initialTBForm2Values = {
  WithoutArm: null,
  WithArmReachGreaterThan5Meters: null,
  NeedAdditionalHandling: null,
}

type ToogleButtonForm2Props = {
  isVisible1: boolean
  onDetectChange2?: (isThereChange: boolean) => void
  listeService?: any
  setListService?: any
  itemProps?: any
  setServiceData?: any
  onSavedForm?: (saved: boolean) => void
  loadListServiceStatus?: Function
  t002?: ListeServiceStatus
}

const ToogleButtonForm2: FC<ToogleButtonForm2Props> = ({
  isVisible1,
  onDetectChange2,
  listeService,
  setListService,
  itemProps,
  setServiceData,
  onSavedForm,
  t002,
  loadListServiceStatus,
}) => {
  const intl = useIntl()
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [serviceT002, setServiceT002] = useState<any>(null)
  const [t1init, setT1init] = useState<any>(initialTBForm2Values)
  const {setAuthMessage, logout} = useAuth()
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const {mode} = useThemeMode()
  const [loading, setLoading] = useState<boolean>(true)

  // const onRefreshListeService2 = () => {
  //   const services: any[] = [...listeService]
  //   const data = services.find((item) => item === itemProps)
  //   if (data) {
  //     const index = services.findIndex((item) => item === itemProps)
  //     if (index === -1) {
  //       //return
  //     }
  //     services.splice(index, 1, {...itemProps, Completed: true})
  //     setServiceData(itemProps)
  //     setListService(services)
  //   }
  // }

  const loadServiceT002 = async () => {
    const response = await getServiceT002(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT002(response?.data?.data)
      setT1init(response?.data?.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadServiceT002()
  }, [])

  const handleClickT002 = async () => {
    try {
      const dataToUpdate = {
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
        WithoutArm: serviceT002?.WithoutArm,
        WithArmReachGreaterThan5Meters: serviceT002?.WithArmReachGreaterThan5Meters,
        NeedAdditionalHandling: serviceT002?.NeedAdditionalHandling,
      }
      const response = await putServiceT002(dataToUpdate)
      if (response?.data?.Status?.Success) {
        if (onSavedForm) {
          onSavedForm(true)
        }
        console.log('Changements enregistrés !')
      }
      await loadServiceT002()
      // await onRefreshListeService2()
      if (loadListServiceStatus) await loadListServiceStatus()
    } catch (error) {
      console.error('Erreur lors de la sauvegarde :', error)
    }
  }

  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT002, t1init) || !serviceT002
  }, [serviceT002, t1init])

  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadServiceT002()
      setShowCancel(false)
    } else {
      setServiceT002({...t1init})
      setShowCancel(false)
    }
  }

  useEffect(() => {
    if (onDetectChange2) {
      onDetectChange2(isDisabled)
    }
  }, [isDisabled, onDetectChange2])

  return (
    <div>
      {isVisible1 && (
        <div className='d-flex flex-column'>
          <form>
            <div className='p-5 mt-8'>
              <div>
                <div className='d-flex justify-content-between'>
                  <div>
                    <label className='fs-4 fw-bold text-gray-700 mb-5'>
                      {intl.formatMessage({id: 'HARDWARE.RELATED.DELIVERY.OPTION'})}
                    </label>
                  </div>
                  <div>{/*<CenterHelp />*/}</div>
                </div>

                <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column'>
                  <label className='fs-5 text-gray-700' style={{flex: 0.5}}>
                    {intl.formatMessage({id: 'WITHOUT.CRANE.ARM'})}
                  </label>
                  <div className='d-flex gap-10' style={{flex: 0.5}}>
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'YES'})}
                      checked={serviceT002?.WithoutArm === true}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT002({...serviceT002, WithoutArm: true})
                      }}
                    />
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'NO'})}
                      checked={serviceT002?.WithoutArm === false}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT002({...serviceT002, WithoutArm: false})
                      }}
                    />
                  </div>
                </div>
                {serviceT002?.WithoutArm === true ? (
                  <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5'>
                    <label className='fs-5 text-gray-700' style={{flex: 0.5}}>
                      {intl.formatMessage({id: 'WITH.CRANE.ARM.EXTENDED.BEYOUND.5M'})}{' '}
                    </label>
                    <div className='d-flex gap-10 mb-5' style={{flex: 0.5}}>
                      <RadioButton
                        classNameContainer='d-flex gap-3 align-items-center'
                        label={intl.formatMessage({id: 'YES'})}
                        checked={serviceT002?.WithArmReachGreaterThan5Meters === true}
                        classNameCheckedActive=''
                        classNameCheckedInactive=''
                        classNameDefaultLabel=''
                        handleClick={() => {
                          setServiceT002({...serviceT002, WithArmReachGreaterThan5Meters: true})
                        }}
                      />
                      <RadioButton
                        classNameContainer='d-flex gap-3 align-items-center'
                        label={intl.formatMessage({id: 'NO'})}
                        checked={serviceT002?.WithArmReachGreaterThan5Meters === false}
                        classNameCheckedActive=''
                        classNameCheckedInactive=''
                        classNameDefaultLabel=''
                        handleClick={() => {
                          setServiceT002({...serviceT002, WithArmReachGreaterThan5Meters: false})
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-5' />
                )}
              </div>

              <div>
                <label className='fs-4 fw-bold text-gray-700 mb-5'>
                  {intl.formatMessage({id: 'DELIVERY'})}
                </label>

                <div className='gap-5 d-flex justify-content-xl-between flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column'>
                  <label className='fs-5 text-gray-700' style={{flex: 0.5}}>
                    {intl.formatMessage({id: 'NEED.FOR.ADDITIONNAL.HANDLING'})}
                  </label>
                  <div className='d-flex gap-10' style={{flex: 0.5}}>
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'YES'})}
                      checked={serviceT002?.NeedAdditionalHandling === true}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT002({...serviceT002, NeedAdditionalHandling: true})
                      }}
                    />
                    <RadioButton
                      classNameContainer='d-flex gap-3 align-items-center'
                      label={intl.formatMessage({id: 'NO'})}
                      checked={serviceT002?.NeedAdditionalHandling === false}
                      classNameCheckedActive=''
                      classNameCheckedInactive=''
                      classNameDefaultLabel=''
                      handleClick={() => {
                        setServiceT002({...serviceT002, NeedAdditionalHandling: false})
                      }}
                    />
                  </div>
                </div>
              </div>

              {!Submitted && (
                <div className='d-flex gap-5 justify-content-end my-5'>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      className='btn btn-dark'
                      disabled={isDisabled}
                      onClick={() => {
                        if (!lodash.isEqual(serviceT002, t1init)) {
                          setShowCancel(true)
                        } else {
                          setServiceT002({...t1init})
                        }
                      }}
                    >
                      {intl.formatMessage({id: 'RESET'})}
                      <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                    </Button>
                  </span>
                  <span style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>
                    <Button
                      type='button'
                      className='btn btn-danger'
                      onClick={handleClickT002}
                      disabled={isDisabled}
                      style={{
                        backgroundColor: mode === 'dark' ? Color.BG_DARK : Color.BG_LIGHT,
                      }}
                    >
                      {intl.formatMessage({id: 'SAVE'})}
                      <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                    </Button>
                  </span>
                </div>
              )}
            </div>
          </form>
          <Modal show={showCancel} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
              <div
                className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                data-bs-theme={mode}
              >
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='fw-bolder text-gray-700 py-3'>
                    {intl.formatMessage({id: 'INFORMATION'})}
                  </div>
                  <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                    <i className='fa fa-close text-danger'></i>
                  </div>
                </div>
                <div className={'text-start py-3'}>
                  <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
                </div>
                <div className='d-flex align-items-center justify-content-evenly'>
                  <button className={'btn btn-secondary'} onClick={onCancelReset}>
                    {intl.formatMessage({id: 'NO'})}
                  </button>
                  {!loading && (
                    <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                      {intl.formatMessage({id: 'YES'})}
                    </button>
                  )}
                  {loading && (
                    <button className={'btn btn-primary'} onClick={() => {}}>
                      {'...'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default ToogleButtonForm2
